import { Deserializable } from '../../protocols/deserializable';

export class MostRecentInvite implements Deserializable {
  public id!: string;
  public email!: string;
  public memberId!: number;
  public employerId!: number;
  public verificationDate!: string;
  public lastInviteSentDate!: string;

  onDeserialize(): void {}
}
